import {
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoDatePicker,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMoneyInputOutlined,
    RaikoNumberInputOutlined,
    RaikoToggleOutlined,
    showErrorMessage, showSuccessMessage,
    showWarningMessage,RaikoFlexAlignEnd
} from "@moeindal/base-raiko-panel-components";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator
} from "../../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {css} from "@emotion/css";
import {useState} from "react";
import {dateIsNotValid, numberIsEmpty} from "../../../util/VariableChecker";
import {AccountService} from "../../../serverService/account/AccountService";
import {useAuthState} from "../../../context/AuthContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function NewAccountFinalStep(
    {
        userInfo,
        guardian,
        setStepper,
        handleAddNewAccountToTable
    }) {

    const [balance, setBalance] = useState(0)
    const [accountCode, setAccountCode] = useState(0);
    const [date, setDate] = useState("");
    const [enabled, setEnabled] = useState(true)

    const service = new AccountService()

    const {fundID} = useAuthState()
    const loading = new LoadingHelper(useLoadingDispatcher())

    function handleGenerateAccount() {
        if (checkConditions()) {
            loading.show()
            service.createNewAccount(
                fundID,
                userInfo[0].id,
                guardian && guardian[0] && guardian[0].id ? guardian[0].id : null,
                balance,
                accountCode,
                date,
                enabled
            ).then(response => {
                showSuccessMessage("حساب جدید با موفقیت افزوده شد.")
                handleAddNewAccountToTable({
                    ...response,
                    ownerNationalCode: userInfo[0].nationalCode,
                    OwnerGroupName: userInfo[0].group,
                    balance: userInfo[0].group,
                })
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkConditions() {
        let message = ""
        let state = false

        if (numberIsEmpty(balance)) {
            message = "لطفا موجودی اولیه ی حساب را وارد نمایید"
        } else if (numberIsEmpty(accountCode)) {
            message = "لطفا شماره ی حساب جدید را وارد نمایید"
        } else if (dateIsNotValid(date)) {
            message = "لطفا تاریخ ساخت حساب را مشخص نمایید"
        } else
            state = true


        if (message && message.length > 0)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn className={css`
          gap: 1.5rem;
        `}>
            <RaikoGridTwoColumn>
                {
                    userInfo && userInfo.length > 0 &&
                    <RaikoCardInfoTypeOne
                        title={userInfo[0].fullName}
                        titleLabel={"مالک حساب"}
                        iconClass={"ic-profile"}
                        items={[
                            RaikoCardInfoTypeOneItemGenerator(
                                "گروه",
                                userInfo[0].groupName
                            ),
                            RaikoCardInfoTypeOneItemGenerator(
                                "کد ملی",
                                userInfo[0].nationalCode
                            ),
                            RaikoCardInfoTypeOneItemGenerator(
                                "شماره همراه",
                                userInfo[0].phoneNumber
                            ),
                        ]}
                    />
                }

                {
                    guardian && guardian.length > 0 ?
                        <RaikoCardInfoTypeOne
                            title={guardian[0].fullName}
                            titleLabel={"قیم حساب"}
                            iconClass={"ic-profile"}
                            items={[
                                RaikoCardInfoTypeOneItemGenerator(
                                    "گروه",
                                    guardian[0].groupName
                                ),
                                RaikoCardInfoTypeOneItemGenerator(
                                    "کد ملی",
                                    guardian[0].nationalCode
                                ),
                                RaikoCardInfoTypeOneItemGenerator(
                                    "شماره همراه",
                                    guardian[0].phoneNumber
                                ),
                            ]}
                        /> :
                        <div className={css`position: relative;`}>
                            <RaikoCardInfoTypeOne
                                title={userInfo[0].fullName}
                                titleLabel={"مالک حساب"}
                                iconClass={"ic-profile"}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "گروه",
                                        userInfo[0].groupName
                                    ),
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "کد ملی",
                                        userInfo[0].nationalCode
                                    ),
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "شماره همراه",
                                        userInfo[0].phoneNumber
                                    ),
                                ]}
                            />

                            <div
                                className={css`
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                  backdrop-filter: blur(3px);
                                  filter: blur(3px);
                                  background: rgba(255, 255, 255, 0.1);
                                  border-radius: 8px;
                                  overflow: hidden;
                                `}
                            />

                            <div
                                className={css`
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                `}
                            >
                            <span className={
                                css`
                                  color: red !important;
                                  font-size: 18px;
                                  font-weight: bold;
                                `}>
                                بدون قیم
                            </span>

                            </div>
                        </div>
                }
            </RaikoGridTwoColumn>

            <RaikoDivider/>

            <RaikoGridOneColumn>
                <RaikoGridTwoColumn>
                    <RaikoNumberInputOutlined
                        labelText={"شماره حساب"}
                        value={accountCode}
                        setValue={setAccountCode}
                    />

                    <RaikoMoneyInputOutlined
                        labelText={"موجودی اولیه (ریال)"}
                        value={balance}
                        setValue={setBalance}
                    />
                </RaikoGridTwoColumn>

                <RaikoDatePicker
                    label={"تاریخ افتتاح"}
                    date={date}
                    setDate={setDate}
                />

                <RaikoToggleOutlined
                    checked={enabled}
                    setChecked={setEnabled}
                    labelText={"فعالسازی"}
                />

            </RaikoGridOneColumn>

            <RaikoFlexAlignEnd>
                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        setStepper(prev => prev - 1)
                    }}
                />

                <RaikoButtonPrimary
                    label={"افتتاح حساب"}
                    onClick={handleGenerateAccount}
                />
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}
